<template>
  <a :href="loginUrl" v-analytics="{label:'header_login'}">ログイン</a>
</template>

<script>
import analytics from '../../../directives/analytics';

export default {
  name      : 'login-button',
  directives: {
    analytics,
  },
  props: {
    loginUrl: {
      type   : String,
      default: '',
    },
  },
};
</script>
